export const OCCUPATIONAL_THERAPIST_NOTES_CONSTANT = [
    // {
    //   sectionHeading: 'Note Type',
    //   rowNumber: 1,
    // },
    // {
    //   noteType: true,
    //   isTemplate: true,
    //   rowNumber: 2,
    //   isEntry: false,
    //   isEdit: false
    // },
    { sectionHeading: 'Patient Information', rowNumber: 3 },
    {
        label: 'Client',
        name: 'clientId',
        type: 'searchableSelect',
        options: [],
        disabled: false,
        required: true,
        rowNumber: 4,
    },
    {
        name: 'date',
        label: 'Date',
        type: 'date',
        required: true,
        rowNumber: 4,
        maxDate: new Date(),
        minDate: new Date('1970-01-01')
    },
    {
        sectionHeading: 'Location Information',
        rowNumber: 5
    },
    {
        addressInfo: true,
        rowNumber: 6
    },
    {
        type: 'sectionTitle',
        title: 'Key Occupational Goals',
        rowNumber: 7
    },
    {
        sectionHeading: 'Self-Care',
        rowNumber: 8
    },
    {
        label: '',
        name: 'selfCare',
        type: 'checkbox',
        options: [
            { label: 'Bathing', value: 'Bathing' },
            { label: 'Dressing', value: 'Dressing' },
            { label: 'Eating', value: 'Eating' },
            { label: 'Toileting', value: 'Toileting' },
            { label: 'Mealtimes', value: 'Mealtimes' },
            { label: 'Daily Routines', value: 'Daily Routines' }
        ],
        required: true,
        rowNumber: 8,
    },
    {
        sectionHeading: 'Rest & Sleep',
        rowNumber: 9
    },
    {
        label: '',
        name: 'restAndSleep',
        type: 'checkbox',
        options: [
            { label: 'Sleeping', value: 'Sleeping' },
            { label: 'Napping', value: 'Napping' },
            { label: 'Relaxation', value: 'Relaxation' },
            { label: 'Sleep Routines', value: 'Sleep Routines' }
        ],
        required: true,
        rowNumber: 10,
    },
    {
        sectionHeading: 'Domestic',
        rowNumber: 11
    },
    {
        label: '',
        name: 'domestic',
        type: 'checkbox',
        options: [
            { label: 'Home Chores', value: 'Home Chores' },
            { label: 'Helping', value: 'Helping' },
            { label: 'Snack prep', value: 'Snack prep' },
            { label: 'Pet care', value: 'Pet care' },
            { label: 'Health management', value: 'Health management' }
        ],
        required: true,
        rowNumber: 12,
    },
    {
        sectionHeading: 'Education',
        rowNumber: 13
    },
    {
        label: '',
        name: 'education',
        type: 'checkbox',
        options: [
            { label: 'Pencil & FM', value: 'Pencil & FM' },
            { label: 'Technology', value: 'Technology' },
            { label: 'Organization', value: 'Organisation' },
            { label: 'Group skills', value: 'Group skills' },
            { label: 'Learning and attention', value: 'Learning and attention' }
        ],
        required: true,
        rowNumber: 14,
    },
    {
        sectionHeading: 'Play and Leisure',
        rowNumber: 15
    },
    {
        label: '',
        name: 'playAndLeisure',
        type: 'checkbox',
        options: [
            { label: 'Play', value: 'Play' },
            { label: 'Social play', value: 'Social play' },
            { label: 'Leisure', value: 'Leisure' },
            { label: 'Sports and GM', value: 'Sports and GM' },
            { label: 'Likes & interests', value: 'Likes & interests' }
        ],
        required: true,
        rowNumber: 16,
    },
    {
        sectionHeading: 'Social Participation',
        rowNumber: 17
    },
    {
        label: '',
        name: 'socialParticipation',
        type: 'checkbox',
        options: [
            { label: 'Family', value: 'Family' },
            { label: 'Peers', value: 'Peers' },
            { label: 'Community', value: 'Community' },
            { label: 'Education', value: 'Education' },
            { label: 'Care supports', value: 'Care supports' }
        ],
        required: true,
        rowNumber: 18,
    },
    {
        sectionHeading: 'Community Access',
        rowNumber: 19
    },
    {
        label: '',
        name: 'communityAccess',
        type: 'checkbox',
        options: [
            { label: 'Physical access', value: 'Physical access' },
            { label: 'Safe transport', value: 'Safe transport' },
            { label: 'Community safety', value: 'Community safety' },
            { label: 'Functional mobility', value: 'Functional mobility' }
        ],
        required: true,
        rowNumber: 20,
    },
    {
        label: 'Other Details',
        name: 'otherDetails',
        type: 'textarea',
        required: false,
        rowNumber: 21,
        minRows: 3,
    },
    {
        type: 'sectionTitle',
        title: 'Key Underlying Performance Areas',
        rowNumber: 22
    },
    {
        label: '',
        name: 'performanceAreas',
        type: 'checkbox',
        options: [
            { label: 'Emotional Regulation', value: 'Emotional Regulation' },
            { label: 'Sensory Processing', value: 'Sensory Processing' },
            { label: 'Cognitive', value: 'Cognitive' },
            { label: 'Social-Communication', value: 'Social-Communication' },
            { label: 'Motor & Praxis', value: 'Motor & Praxis' },
            { label: 'Relationships', value: 'Relationships' }
        ],
        required: true,
        rowNumber: 23,
    },
    {
        label: 'Performance Area Details',
        name: 'performanceAreaDetails',
        type: 'textarea',
        required: false,
        rowNumber: 24,
        minRows: 3,
    },
    {
        type: 'sectionTitle',
        title: 'Progress Feedback',
        rowNumber: 25
    },
    {
        label: 'Progress Feedback (incl. home/school activities & perceived goal progress)  ',
        name: 'progressFeedback',
        type: 'textarea',
        required: true,
        rowNumber: 26,
        minRows: 3,
    },
    {
        type: 'sectionTitle',
        title: 'Presentation',
        rowNumber: 27
    },
    {
        label: 'OT Activities',
        name: 'otActivities',
        type: 'textarea',
        required: true,
        rowNumber: 28,
        minRows: 3,
    },
    {
        label: 'Observations',
        name: 'observations',
        type: 'textarea',
        required: true,
        rowNumber: 29,
        minRows: 3,
    },
    {
        label: 'OT Suggestions',
        name: 'otSuggestions',
        type: 'textarea',
        required: true,
        rowNumber: 30,
        minRows: 3,
    }
]

export const OCCUPATIONAL_THERAPIST_NOTES_CONSTANT_INITIAL_VALUES = {
    clientId: '',
    noteType: '',
    assessmentType:'',
    date: '',
    addrInfo: {
        st1: '',
        st2: '',
        country: '',
        state: '',
        city: '',
        zipCode: '',
        primaryPhone: '',
        accuracy:90
    },
    occupationGoals: {
        selfCare: [],
        restAndSleep: [],
        domestic: [],
        education: [],
        playAndLeisure: [],
        socialParticipation: [],
        communityAccess: [],
        otherDetails: ''
    },
    performanceAreas: [],
    performanceAreaDetails: '',
    progressFeedback: '',
    presentation: {
        otActivities: '',
        observations: '',
        otSuggestions: ''
    }
}

export const OCCUPATIONAL_THERAPIST_NOTES_CONSTANT_ENTRY = ()=> {
    return [
    // {
    //   noteType: true,
    //   isEntry : true,
    //   rowNumber: 1,
    //   isEdit: false
    // },
    {
        label: 'Client',
        name: 'clientId',
        type: 'searchableSelect',
        options: [],
        disabled: true,
        required: true,
        rowNumber: 3,
    },
    {
        addressInfo: true,
        rowNumber: 4,
        disabled: true,
    },
    {
        type: 'sectionTitle',
        title: 'Occupational Goals',
        rowNumber: 5
    },
    {
        label: '',
        name: 'occupationGoals',
        type: 'checkbox',
        options: [
            { label: 'Self-Care', value: 'Self-Care' },
            { label: 'Rest & Sleep', value: 'Rest & Sleep' },
            { label: 'Domestic', value: 'Domestic' },
            { label: 'Education', value: 'Education' },
            { label: 'Play and Leisure', value: 'Play and Leisure' },
            { label: 'Social Participation', value: 'Social Participation' },
            { label: 'Community Access', value: 'Community Access' },
        ],
        required: true,
        disabled: true,
        rowNumber: 6,
    },
    {
        label: 'Occupational Goals Details',
        name: 'occupationGoalsDetails',
        type: 'textarea',
        required: false,
        rowNumber: 7,
        disabled: true,
        minRows: 3,
    },
    {
        type: 'sectionTitle',
        title: 'Performance Areas',
        rowNumber: 8
    },
    {
        label: '',
        name: 'performanceAreas',
        type: 'checkbox',
        options: [
            { label: 'Emotional Regulation', value: 'Emotional Regulation' },
            { label: 'Sensory Processing', value: 'Sensory Processing' },
            { label: 'Social-Communication', value: 'Social-Communication' },
            { label: 'Motor & Praxis', value: 'Motor & Praxis' },
            { label: 'Relationships', value: 'Relationships' },
            { label: 'Cognitive', value: 'Cognitive' },
        ],
        disabled: true,
        required: true,
        rowNumber: 9,
    },
    {
        label: 'Performance Area Details',
        name: 'performanceAreaDetails',
        type: 'textarea',
        required: false,
        disabled: true,
        rowNumber: 10,
        minRows: 3,
    },
    {
        type: 'sectionTitle',
        title: 'Progress Note',
        rowNumber: 11
    },
    {
        label: 'Progress Note',
        name: 'progressNotes',
        type: 'textarea',
        required: false,
        rowNumber: 12,
        minRows: 3,
    },
    {
      sectionHeading: 'Next Session',
      rowNumber: 13,
    },
    {
        label: 'Next Session',
        name: 'nextSession',
        type: 'date',
        required: false,
        rowNumber: 14,
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        minDate: new Date(new Date().setDate(new Date().getDate() + 1))
    },

]}

export const OCCUPATIONAL_THERAPIST_NOTES_CONSTANT_ENTRY_INITIAL_VALUES = {
    clientId: '',
    occupationGoals: [],
    performanceAreas: [],
    performanceAreaDetails: '',
    progressFeedback: '',
    progressNotes: '',
    nextSession: '',
    timeIn: '',
    timeOut: '',
    noteType: '',
    startDate: '',
    endDate: '',
}
